import React from 'react'
import PurchaseSummary from './PurchaseSummary'

export default function OpenFishPurSummary() {
    return (
        <PurchaseSummary xState={'OPEN'} />
    )
}
